export class CodeListKey{
    appId : string = "";
    keyId : string = "";
    keyFr : string = "";
    keyNl : string = "";
    keyX : string = "";
    keyValNum : number = 0;
    keyValString : string = "";
  }

  export class CodeListKeyLong{
    appId : string = "";
    keyId : string = "";
    keyFr : string = "";
    keyNl : string = "";
    keyX : string = "";
    keyFrLong : string = "";
    keyNlLong : string = "";
    keyXLong : string = "";
    keyValNum : number = 0;
    keyValString : string = "";
  }

  export class CodeList
  {
      constructor()
      {
          this.keys = new Array<CodeListKey>();
      }
  
      keys: Array<CodeListKey>;
  }

  export class CLPrestKey{
    cd_prest : string = "";
    lb_prest_n : string = "";
    lb_prest_court_n : string = "";
    lb_prest_f : string = "";
    lb_prest_court_f : string = "";
    lb_prest_x : string = "";
    lb_prest_court_x : string = "";
  }

  export class CodeListPrest
  {
      constructor()
      {
          this.keys = new Array<CLPrestKey>();
      }
  
      keys: Array<CLPrestKey>;
  }

  
  export class SalarySimFormCodeList{
    clMaritalStatus = new Array<CodeListKey>(); // ETAT_CIVIL_IBRUNET
    clLocalUnit = new Array<CodeListKey>(); // IBRUNET_UNITE_LOCALE
    clPartner = new Array<CodeListKey>(); // CONJOINT_IBRUNET
    clContr = new Array<CodeListKey>(); // TYPE_CONTRAT_IBRUNET
    clContrPlus = new Array<CodeListKey>(); // TYPE_CONTRAT_IBRUNET_PLUS
    clCdHire = new Array<CodeListKey>(); // IBRUNET_CD_ENGAGEMENT
    clFullTime  = new Array<CodeListKey>(); // TEMPS_PLEIN_PARTIEL_IBRUNET
    clDeduction = new Array<CodeListKey>(); // SOUMIS_PRECOMPTE_IBRUNET_PLUS
    clONSSSubmit = new Array<CodeListKey>(); // SOUMIS_ONSS_IBRUNET_PLUS
    clEmplWorkforce = new Array<CodeListKey>(); // EFFECTIF_EMPL_IBRUNET_PLUS
}


export enum FieldConstraintType
{
    EndOfYearBonus = 0,
    GrossSubmittedAmount = 1
}

export class FieldConstraint
{
  constraintType : FieldConstraintType = FieldConstraintType.EndOfYearBonus;
  constraintValue : string = '';
}
